import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { IDocumentsVariationsList, IIdentifierInscoList, IOverrideList, IPayerFormOverride, IPayerFormVariationItem, IScenarioItem } from "../Infrastructure/Interfaces"

const IdentifierInscoInitialState: IIdentifierInscoList = {
    loading : false,
    inscoList: []
}

const ItemInitialState: IScenarioItem = {
    scenarioid: 0,
        documentid: 0,
        variationid: 0,
        name: '',
        billing_admin: '',
        billing_system: '',
        billing_client: '',
        chart_required: true,
        eob_required: true,
        claim_required: true,
        deliver_option: '',
        deliver_regard: '',
        deliver_to_email_address: '',
        fax_to: '',
        fax_to_faxnumber: '',
        fax_user: '',
        fax_secret: '',
        requestor_first_name: '',
        requestor_last_name: '',
        requestor_phone: '',
        requestor_fax: '',
        requestor_email_address: '',
        requestor_signature: '',
        requestor_company_name: '',
        requestor_company_address1: '',
        requestor_company_address2: '',
        requestor_company_city: '',
        requestor_company_state: '',
        requestor_company_zip: '',
        requestor_alternate_contact: '',
        page_limit: '',
        next_delivery: '',
        upload_channel: '',
        default_channel: true
  }

  
const documentsVariationsInitialState: IDocumentsVariationsList = {
  loading: true,
  documentsList: [],
  variationsList: []
};

const overridesInitialState : IOverrideList ={
    loading: false,
    overrideList: []
}
  
  const ScenariosItemSlice = createSlice({
    name:'ScenariosItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setScenariosItem:(state,action)=>{
            state.value = action.payload
        }
    }
  })

  export const fetchIdentifierInscoList = createAsyncThunk(
    'fetchIdentifierInscoList',
    async (scenarioid: number) => {
      const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
      const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
  
      return axios.get(tokenurl).then(res => {
        if (res.data.success) {
          return axios
            .get(baseurl + '/Appeal/get_scenario?id=' + scenarioid, {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + res.data.token,
              },
            })
            .then(response => {
              if (response.data.success) {
                return response.data.result;
              }
            });
        }
      });
    }
  );
  
  const IdentifierInscoListSlice = createSlice({
    name: 'identifierinscolist',
    initialState: IdentifierInscoInitialState,
    reducers: {},
    extraReducers: builder => {
    builder.addCase(fetchIdentifierInscoList.fulfilled, (state, action) => {
        state.loading = false;
        state.inscoList = action.payload;
    });
    builder.addCase(fetchIdentifierInscoList.pending, (state, action) => {
        state.loading = true;
    });
    builder.addCase(fetchIdentifierInscoList.rejected, (state, action) => {
        state.loading = false;
        state.inscoList = [];
    });
    },
  });

  export const fetchFormDropdownList = createAsyncThunk(
    'fetchFormDropdownList',
    async () => {
      const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
      const tokenurl = process.env.REACT_APP_TOKEN_URL_PAYER_FORM as string;
  
      return axios.get(tokenurl).then(res => {
        if (res.data.success) {
          return axios.get(baseurl + "/App/api/get_form_dropdown", { headers: {Pragma: 'no-cache', Authorization: "Bearer " + res.data.token } })
            .then(response => {
              if (response.data.success) {
                return response.data;
              }
            }).catch(Error => {
              {console.log('error',Error)}
            });
        }
      });
    }
  );
  
  const GetFormDropdownListSlice = createSlice({
    name: 'getformdropdown',
    initialState: documentsVariationsInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchFormDropdownList.fulfilled, (state, action) => {
        state.loading = false;
        state.documentsList = action.payload.documents;
        state.variationsList = action.payload.variations;
      });
      builder.addCase(fetchFormDropdownList.rejected, (state, action) => {
        state.loading = false;
        state.documentsList = [];
        state.variationsList = [];
      });
      builder.addCase(fetchFormDropdownList.pending, (state, action) => {
        state.loading = true;
      });
    },
  });

  export const fetchOverridesList = createAsyncThunk(
    'fetchOverridesList',
    async (scenarioid: number) => {
      const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
      const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
  
      return axios.get(tokenurl).then(res => {
        if (res.data.success) {
          return axios
            .post(baseurl + '/Appeal/get_scenario_form_override?id=' + scenarioid,null, {
              headers: {
                Pragma: 'no-cache',
                Authorization: 'Bearer ' + res.data.token,
              },
            })
            .then(response => {
              if (response.data.success) {
                return response.data.result;
              }
            });
        }
      });
    }
  );

  const OverridesListSlice = createSlice({
    name: 'getoverrideslist',
    initialState: overridesInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchOverridesList.fulfilled, (state, action) => {
        state.loading = false;
        state.overrideList = action.payload;
      });
      builder.addCase(fetchOverridesList.rejected, (state, action) => {
        state.loading = false;
        state.overrideList = []
      });
      builder.addCase(fetchOverridesList.pending, (state, action) => {
        state.loading = true;
      });
    },
  });

  export const {setScenariosItem} = ScenariosItemSlice.actions;

  export const ScenariosItemReducer = ScenariosItemSlice.reducer;

  export const IdentifierInscoListReducer = IdentifierInscoListSlice.reducer;

  export const GetFormDropdownListReducer = GetFormDropdownListSlice.reducer;

  export const OverridesListReducer = OverridesListSlice.reducer;